import React from 'react';
import { Card, CardContent } from './ui/card';
import { RefreshCw, Zap, Users, Palette } from 'lucide-react';

export const FeaturesSection = () => {
  const features = [
    {
      icon: RefreshCw,
      title: "¿Utilizas Plan Canje?",
      description: "Da la posibilidad a tus clientes para que puedan cotizar online y obtener un valor estimado de su iPhone usado.",
      color: "text-green-600",
      bgColor: "bg-green-50"
    },
    {
      icon: Zap,
      title: "Listados con Plantillas",
      description: "No pierdas tiempo creando tus productos desde cero. Nuestras plantillas ya cuenta con especificaciones, colores, y todo lo necesario.",
      color: "text-[#0052FF]",
      bgColor: "bg-blue-50"
    },
    {
      icon: Users,
      title: "CRM Todo en Uno",
      description: "Gestiona tu inventario, promociones y pedidos desde un único panel facil de usar e intuitivo.",
      color: "text-purple-600",
      bgColor: "bg-purple-50"
    },
    {
      icon: Palette,
      title: "Marca y Profesional",
      description: "Tu tienda, tu marca. Personaliza tu sitio para reflejar la identidad única de tu negocio.",
      color: "text-orange-600",
      bgColor: "bg-orange-50"
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#0A2540]">
            No somos solo una tienda digital
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Con tu tienda <em>DigiStore</em> tus clientes ven tus productos de una manera profesional. Contamos con funcionalidades especiales iPhone y tecnología moderna.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <Card
                key={index}
                className="group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border-0 shadow-lg"
              >
                <CardContent className="p-8 text-center">
                  <div className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl ${feature.bgColor} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <IconComponent className={`${feature.color} w-8 h-8`} />
                  </div>

                  <h3 className="text-xl font-bold text-[#0A2540] mb-4">
                    {feature.title}
                  </h3>

                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        {/* <div className="text-center mt-16">
          <p className="text-lg text-gray-600 mb-6">
            ¿Listo para llevar tu negocio al proximo nivel?
          </p>
          <button className="bg-[#0052FF] hover:bg-[#0042CC] text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 transform hover:scale-105 hover:shadow-lg">
            Mira todo lo que ofrecemos
          </button>
        </div> */}

      </div>
    </section>
  );
};